import { call, takeLatest } from 'redux-saga/effects';
import BackendService from 'services/BackendService';
import schemas from 'containers/App/modules/api/schema';
import { api } from 'containers/App/modules/async.saga';
import { crcFailuresEntityActions } from './crcFailuresEntity.slice';
import { parseFetchAllSuccess } from './crcFailures.parsers';

function* searchCrcFailures(action) {
  yield call(api, {
    apiFn: ({ data }) => BackendService.searchCrcFailureEvents({ data }),
    parseSuccessResponseFn: parseFetchAllSuccess,
    schema: [schemas.crcFailureEvents],
    // payload is already prepared by entity slice's requestPrepareFn
    params: { data: action.payload },
    actions: [
      crcFailuresEntityActions.fetchCrcFailuresPending,
      crcFailuresEntityActions.fetchCrcFailuresSuccess,
      crcFailuresEntityActions.fetchCrcFailuresFailure,
    ],
  });
}

export default function* watchCrcFailuresSaga() {
  yield takeLatest(crcFailuresEntityActions.fetchCrcFailures, searchCrcFailures);
}


